<template>
  <div style="padding: 0 10px;box-sizing: border-box;">
    <el-row :gutter="20" style="margin-top: 10px;margin-right:0;">
      <el-col :span="4">
        <div class="grid-content bg-purple">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
          <el-tree :filter-node-method="filterNode" ref="tree" :props="defaultProps" :data="deptTree" node-key="resModule" default-expand-all :expand-on-click-node="false" @node-click="deptNodeClick"> </el-tree>
        </div>
      </el-col>
      <el-col :span="20">
        <div class="grid-content bg-purple">
          <el-form :inline="true" size="small" :model="query" style="margin-top: 10px;">
            <el-form-item label="资源名称">
              <el-input v-model="query.resName" placeholder="资源名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getUnitUserPage()"><i class="el-icon-search"></i> 查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tableData" :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#606266',height:'54px'}" border style="width: 100%" height="650px" stripe>
            <el-table-column align="center" prop="resTypeName" label="资源类型" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="resCode" label="资源编码" width="170" show-overflow-tooltip> </el-table-column>
            <el-table-column align="center" prop="resName" label="资源名称" width="150" show-overflow-tooltip> </el-table-column> 
            <el-table-column align="center" prop="resModule" label="资源所属模块名称" width="160" show-overflow-tooltip> </el-table-column> 
            <el-table-column align="center" prop="createTime" label="创建日期" width="150" show-overflow-tooltip> </el-table-column>
            <el-table-column align="center" prop="updateTime" label="最近修改日期" width="140" show-overflow-tooltip> </el-table-column>
            <el-table-column align="center" prop="resVersion" label="版本号" show-overflow-tooltip> </el-table-column>
            <el-table-column align="center" prop="ops" label="操作" fixed="right" width="140"> 
              <template slot-scope="scope">
                <!-- <a :href="'https://cloud.themis.com.cn/api/baseService/download/'+ scope.row.fileId">下载</a> -->
                <el-button @click="deleteUnitUserFunc(scope.row)" type="text" size="small">下载</el-button>
              </template>
            </el-table-column>
        </el-table>
        <el-pagination style="float: right;margin-top: 10px;" :page-sizes="tablePage.pageSizeList" layout="sizes,prev,pager,next" @current-change="changePage" @size-change="changeSize" :total="tablePage.tableCount"></el-pagination>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { getInfo } from "@/cookie";
import axios from "axios";
import { getToken } from '@/cookie';
import { Message,MessageBox } from 'element-ui';
import { treeUnitDept,getBaseResourceLastVersion,resModuleList,listUnitDept } from "@/api/dept";
import { listUnitUser,saveUnitUser,deleteUnitUser,resetUnitSystemPassword } from "@/api/unitUser";

export default {
  name: "Configure",
  components: {  },
  data() {
    return {
      filterText:"",
      query: {
        resName: "",
        resModule:""
      },
      defaultProps: {
        children: 'children',
        label: 'resModule'
      },
      tableData: [],
      tablePage : {
        pageNum: 1,
        pageSize: 10,
        tableCount: 50,
        pageSizeList: [10,20]
      },

      deptTree : [],
      deptList : [],
      currentDeptId: '',
      currentDeptName:'【-】用户',

      unitUserInfo : {
          id: '',
          deptId:'',
          fullName:'',
          userName:'',
          phoneNumber:'',
          email:'',
          remarks:'',
          isEdit:false,
      },
      userDialogVisible: false,
      selectDeptOptions: [],

    };
  },
  created() {
     let info_ = getInfo();
     this.userInfo = {...info_};
     this.getTreeDepts();
     this.getUnitUserPage();
     this.getListDeptInfos();
  },
  watch: {
    filterText(val) {
        this.$refs.tree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
    
    //获取数据
    getUnitUserPage(){
        let where = this.query;
            where.pageNum = this.tablePage.pageNum;
            where.pageSize = this.tablePage.pageSize;
        getBaseResourceLastVersion(where).then(res => {
            this.tableData = res.data.rows;
            this.tablePage.tableCount = res.data.total;
        });
    },
     //切换分页
    changePage(val1){
        this.tablePage.pageNum = val1;
        this.getUnitUserPage();
    },

    //切换分页
    changeSize(val) {
        this.tablePage.pageSize = val;
        this.getUnitUserPage();
    },

    //单位部门
    getTreeDepts(){
      resModuleList({}).then(res => {
          this.deptTree = res.data;
      });
    },
    //点击
    deptNodeClick(data) {
        this.query.resModule=data.resModule
        this.getUnitUserPage();
    },

    //获取部门选择下拉框
    getListDeptInfos(){
      listUnitDept({}).then(res => {
        this.selectDeptOptions = res.data;
      });
    },
    //重置信息
    resetUnitUserInfo(){
      this.unitUserInfo = {
          id: '',
          deptId:'',
          fullName:'',
          userName:'',
          phoneNumber:'',
          email:'',
          remarks:'',
          isEdit : false,
      }
    },
    //打开编辑用户弹窗
    showEditUnitUserDialog(row){
        this.resetUnitUserInfo();
        this.unitUserInfo = {...row};
        this.unitUserInfo.isEdit = true;
        this.userDialogVisible = true;
    },
    //保存用户信息
    saveUnitUserFunc(){
      let this_ = this;
      this.$nextTick(() => {
        this_.$refs.unitUserForm.validate((valid) => {
            if(valid){
              let param = this_.unitUserInfo;
              if(param.deptId == null || param.deptId == ''){
                param.deptId = this_.currentDeptId;
              }
              this_.unitUserInfo.loading = true;
              saveUnitUser(param).then(res => {
                  this_.unitUserInfo.loading = false;
                  if(res.code == 200){
                    Message.success('保存成功'); 
                    this_.unitUserInfo.dialogFormVisible = false;
                    this_.getUnitUserPage();
                  } else {
                    Message.error(res.msg);
                  }
              });
            } 
        });
      });
    },
    getFileName(res){
      const contentDisposition = res.headers.get('content-disposition');
      if (!contentDisposition) return null;
      let fileName = contentDisposition.split('attachment; filename=')[1]
       return decodeURIComponent(fileName)
    },
    //删除用户
    async deleteUnitUserFunc(row){
      // try {
      //   const response = await axios.get(`http://192.168.3.54:8080/api/baseResource/download/${row.fileId}`, {
      //     responseType: 'blob',
      //     headers: {
      //       'Content-Type': 'multipart/form-data',
      //       'Authorization' : getToken()
      //     }
      //   });
      //   let fileName = this.getFileName(response);
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //    const a = document.createElement('a');
      //    a.href = url;
      //     a.download = fileName;
      //     a.click();
      //     window.URL.revokeObjectURL(url);
      // }catch (error) {

      // }
      window.location.href = 'http://192.168.3.54:8080/api/baseResource/download/' + row.fileId;
    },
    //关闭用户弹窗
    closeUserDialog(){
      this.userDialogVisible = false;
      this.getUnitUserPage();
    },

    //重置用户密码
    resetPassword(row){
      let id = row.id;
      MessageBox.prompt('请输入重置后密码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
          inputValidator:(val) => {
              if(val == '' || val == null){
                  return '密码不能为空';
              }
          }
      }).then(({ value }) => {
        resetUnitSystemPassword({userId:id,password:value}).then(res => {
            if(res.code == 200){
               Message.success("操作成功"); 
            } else {
               Message.success(res.msg); 
            }
        });
      }).catch(() => {
               
      });
    },


  },
};
</script>


<style scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    font-size: 15px;
    padding-right: 8px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
   border: 1px solid #f3f3f3;
   padding: 10px;
   box-sizing: border-box;
  }
  .bg-purple-light {
    /* background: #e5e9f2; */
  }
  .grid-content {
    border-radius: 4px;
    min-height: 770px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>


// WEBPACK FOOTER //
// src/views/components/applicationStore.vue